module.exports = __webpack_public_path__ + "static/media/cost.c336adfd.svg";